import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { MpaNavigationMasterPageConfig } from '../types'
import { name } from '../symbols'

export const mpaNavigationMasterPageConfig: MasterPageConfigFn<MpaNavigationMasterPageConfig> = ({
	api,
}: VsmContext) => {
	const transitionName = api.page.getPageTransition()
	const hasPageTransition = transitionName !== null && transitionName !== 'none'

	return {
		hasPageTransition,
	}
}

export const mpaNavigationMasterPageConfigEntry: MasterPageConfigEntry<MpaNavigationMasterPageConfig> = {
	name,
	configFactory: mpaNavigationMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmMpaNavigationMasterPageConfig',
}
